var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ticketNote" } }, [
    _c(
      "div",
      { staticClass: "vo-card" },
      [
        _c("div", { staticClass: "header-small" }, [_vm._v("Notes")]),
        _vm._v(" "),
        _c("div", { staticClass: "details notes" }, [
          _c(
            "div",
            { staticClass: "section", staticStyle: { "margin-bottom": "0" } },
            [
              _c("v-text-field", {
                ref: "inputDescription",
                attrs: {
                  type: "text",
                  rules: _vm.noteRules.note,
                  label: "Description",
                  "multi-line": "",
                  "no-resize": "",
                  rows: "2",
                  maxlength: "2000"
                },
                model: {
                  value: _vm.note.note,
                  callback: function($$v) {
                    _vm.$set(_vm.note, "note", $$v)
                  },
                  expression: "note.note"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                ref: "inputMaterials",
                attrs: {
                  type: "text",
                  rules: _vm.noteRules.material,
                  label: "Materials Used",
                  maxlength: "200"
                },
                model: {
                  value: _vm.note.material,
                  callback: function($$v) {
                    _vm.$set(_vm.note, "material", $$v)
                  },
                  expression: "note.material"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "small-fields" },
                [
                  _c("v-text-field", {
                    ref: "inputLabour",
                    staticClass: "small-input",
                    attrs: {
                      type: _vm.numberInputType,
                      rules: _vm.noteRules.number,
                      label: "Labour Hours"
                    },
                    model: {
                      value: _vm.note.timeTakenHours,
                      callback: function($$v) {
                        _vm.$set(_vm.note, "timeTakenHours", $$v)
                      },
                      expression: "note.timeTakenHours"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    ref: "inputCost",
                    staticClass: "small-input",
                    attrs: {
                      type: _vm.numberInputType,
                      rules: _vm.noteRules.number,
                      label: "Cost"
                    },
                    model: {
                      value: _vm.note.cost,
                      callback: function($$v) {
                        _vm.$set(_vm.note, "cost", $$v)
                      },
                      expression: "note.cost"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "save-note",
                  attrs: {
                    loading: _vm.noteLockout,
                    flat: "",
                    color: "primary"
                  },
                  on: { click: _vm.createNote }
                },
                [_vm._v("Save Note")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "clear" })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.page.ticketNotes.list
          ? _c("vo-list", {
              staticClass: "list",
              attrs: { list: _vm.page.ticketNotes.list },
              scopedSlots: _vm._u([
                {
                  key: "itemSlot",
                  fn: function(item) {
                    return _c("div", { staticClass: "note" }, [
                      _c("div", { staticClass: "user" }, [
                        _c(
                          "div",
                          { staticClass: "avatar" },
                          [
                            _c("vo-avatar", {
                              attrs: {
                                size: 30,
                                user: _vm.$store.getters.user(
                                  _vm.$store.getters.ticketNote(item.item)
                                    .createdBy
                                )
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$store.getters.user(
                                _vm.$store.getters.ticketNote(item.item)
                                  .createdBy
                              ).fullName
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "date" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("dateTimeShorthand")(
                                _vm.$store.getters.ticketNote(item.item).created
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "note-content" }, [
                        _vm.$store.getters.ticketNote(item.item).note
                          ? _c("div", { staticClass: "item" }, [
                              _c("div", { staticClass: "name" }, [
                                _vm._v("Description")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.getters.ticketNote(item.item)
                                      .note
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$store.getters.ticketNote(item.item).material
                          ? _c("div", { staticClass: "item" }, [
                              _c("div", { staticClass: "name" }, [
                                _vm._v("Materials Used")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$store.getters.ticketNote(item.item)
                                      .material
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "small-fields" }, [
                          _vm.$store.getters.ticketNote(item.item)
                            .timeTakenHours
                            ? _c("div", { staticClass: "small-field" }, [
                                _c("div", { staticClass: "name" }, [
                                  _vm._v("Labour Hours")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$store.getters.ticketNote(item.item)
                                        .timeTakenHours
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.$store.getters.ticketNote(item.item).cost
                            ? _c("div", { staticClass: "small-field" }, [
                                _c("div", { staticClass: "name" }, [
                                  _vm._v("Cost")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("money")(
                                        _vm.$store.getters.ticketNote(item.item)
                                          .cost
                                      )
                                    )
                                  )
                                ])
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  }
                }
              ])
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08c6844e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08c6844e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TicketNote.vue
// module id = 608
// module chunks = 4